// removed by extract-text-webpack-plugin
module.exports = {"line":"Chl7z2gxsj4kYoYHOmUjC","title":"_1Od4sNNNA_mTDFZqvMFtje","labelBox":"RQlXvuQfZT2-znZOF4Coa","label":"_3hNKGolsayzCqE3P5eL5vl","icon":"_3Hs0VQ2sXSxrcXHiXHPH9F","dec":"_2GlPOElho6DrxVXyYX-YLj","moreButtonBox":"_2rL4l--UlYyFKZXQ7Kf1sG","more":"_1A_E1xRzMuyj0_jJxGqRi-","moreArrow":"_1w_KxjXaQvL4A4EarlVgP-","moreDec":"LjiutcZSY8WSykZ7UmY85","moreBox":"_2sc8PXk4jlK0Mbd_-1Zybg","show":"_2AHMAVyFCFV0MQN2umkEeH"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Verify/Verify.module.less
// module id = 770
// module chunks = 0